import React from 'react';
import {
  GlobalStyles,
  SurveyGlobalStyles,
  CutomToastContainer,
} from '@deeptrue-frontend/ui';

import StoreProvider from 'components/StoreProvider/StoreProvider';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import ThemeProvider from 'components/ThemeProvider/ThemeProvider';
import HeadProvider from 'components/HeadProvider/HeadProvider';
import { history } from 'consts/routing';
import Routes from 'components/Routes/Routes';
import TokenChecker from 'components/TokenChecker/TokenChecker';
import IntlProvider from 'components/IntlProvider';
import ErrorBoundary from 'pages/ErrorBoundary';

import 'react-toastify/dist/ReactToastify.min.css';

const App = () => (
  <StoreProvider.Provider>
    <TokenChecker>
      <IntlProvider.Provider>
        <ThemeProvider>
          <HeadProvider.Provider />
          {/* @ts-ignore */}
          <RouterProvider.Provider history={history}>
            <ErrorBoundary>
              <Routes />
            </ErrorBoundary>
          </RouterProvider.Provider>
          <CutomToastContainer />
          <GlobalStyles />
          <SurveyGlobalStyles />
        </ThemeProvider>
      </IntlProvider.Provider>
    </TokenChecker>
  </StoreProvider.Provider>
);

export default App;
